import emitter from './eventEmitter';

export default emitter;
